import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import 'react-phone-input-2/lib/style.css';

interface CountryFlagProps {
  countryCode?: string;
}

// Country code to name mapping
const countryNames: { [key: string]: string } = {
  us: 'United States',
  gb: 'United Kingdom',
  ca: 'Canada',
  au: 'Australia',
  de: 'Germany',
  fr: 'France',
  it: 'Italy',
  es: 'Spain',
  nl: 'Netherlands',
  be: 'Belgium',
  ch: 'Switzerland',
  at: 'Austria',
  dk: 'Denmark',
  se: 'Sweden',
  no: 'Norway',
  fi: 'Finland',
  ie: 'Ireland',
  pt: 'Portugal',
  gr: 'Greece',
  pl: 'Poland',
  cz: 'Czech Republic',
  hu: 'Hungary',
  ro: 'Romania',
  bg: 'Bulgaria',
  hr: 'Croatia',
  sk: 'Slovakia',
  si: 'Slovenia',
  ee: 'Estonia',
  lv: 'Latvia',
  lt: 'Lithuania',
  jp: 'Japan',
  cn: 'China',
  kr: 'South Korea',
  in: 'India',
  br: 'Brazil',
  mx: 'Mexico',
  ar: 'Argentina',
  cl: 'Chile',
  co: 'Colombia',
  pe: 'Peru',
  ve: 'Venezuela',
  za: 'South Africa',
  eg: 'Egypt',
  ng: 'Nigeria',
  ke: 'Kenya',
  nz: 'New Zealand',
  sg: 'Singapore',
  my: 'Malaysia',
  th: 'Thailand',
  id: 'Indonesia',
  ph: 'Philippines',
  vn: 'Vietnam',
  tr: 'Turkey',
  il: 'Israel',
  sa: 'Saudi Arabia',
  ae: 'United Arab Emirates',
  ru: 'Russia',
  ua: 'Ukraine',
};

const CountryFlag: React.FC<CountryFlagProps> = ({ countryCode = 'us' }) => {
  // Convert country code to lowercase for the flag class
  const code = countryCode?.toLowerCase() || 'us';

  // Get country name from mapping
  const countryName = useMemo(() => {
    return countryNames[code] || code.toUpperCase();
  }, [code]);

  return (
    <Tooltip title={countryName} placement="top">
      <FlagContainer className="react-tel-input">
        <div className={`flag ${code}`} />
      </FlagContainer>
    </Tooltip>
  );
};

const FlagContainer = styled.div`
  display: inline-block;
  width: auto !important;
  flex-shrink: 0;
`;

export default CountryFlag;
